import TpWidgetMicro from "../common/TpWidgetMicro";
import TpWidget from "../../atoms/document/TpWidget";
import ResponsiveImage from "../../atoms/image/ResponsiveImage";
import { CONSTANTS } from "../../../util/utils";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export default function Hero({ data }) {
  const url =
    process.env.APP_MODE === "live"
      ? `${CONSTANTS.live.universalSignupUrl}`
      : `${CONSTANTS.staging.universalSignupUrl}`;
  return (
    <section
      className={`container grid--default has-align-top hero--default lg:mb-10 md:pb-10`}
    >
      <article className={`lg:maxw-mds text-left`}>
        <h1
          className="text-xl lg:mb-2.5 md:mb-2"
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
        {data.hasOwnProperty("desc") &&
          data.desc.map((item, index) => {
            return (
              <p
                className="lg:maxw-md lg:mt-2 lg:mb-2 md:mb-1.5"
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
              />
            );
          })}
        {data.hasOwnProperty("promoFeatures") && (
          <>
            <p
              className="lg:maxw-md"
              dangerouslySetInnerHTML={{ __html: data.heading }}
            />
            <ol className="ordered-bulletin ticked-bulletin text-sm">
              {data.promoFeatures.map((item, index) => {
                return (
                  <li
                    data-id={index + 1}
                    key={index}
                    dangerouslySetInnerHTML={{ __html: item }}
                    className={
                      index === 0 ? "lg:mb-1 md:mb-1" : "lg:mb-1 md:mb-0"
                    }
                  />
                );
              })}
            </ol>
            <p
              className="lg:maxw-md lg:mb-2 md:mt-2 md:mb-2"
              dangerouslySetInnerHTML={{ __html: data.text }}
            />
          </>
        )}
        {data.hasOwnProperty("cta") && (
          <div className="lg:mt-5 lg:mb-5 md:mt-4 md:mb-2.5">
            <a
              href={`${url}${data.cta.href}`}
              className="btn-primary lg:px-10 md:w-100"
              id={data.cta.id}
            >
              <span>{data.cta.text}</span>
            </a>
          </div>
        )}
        {data.hasOwnProperty("ctaWithLogo") && (
          <div className="cta-with-logo lg:mt-5 lg:mb-5 md:mt-4 md:mb-5">
            <a
              href={`${url}${data.ctaWithLogo.btn.href}`}
              className="btn-primary lg:px-10 lg:mr-6 md:w-100"
              id={data.ctaWithLogo.btn.id}
            >
              <span>{data.ctaWithLogo.btn.text}</span>
            </a>
            <figure>
              <img
                width={data.ctaWithLogo.img.dimensions[0]}
                height={data.ctaWithLogo.img.dimensions[1]}
                src={data.ctaWithLogo.img.src}
                alt={data.ctaWithLogo.img.alt}
                className="md:mt-4 w-auto"
              />
            </figure>
          </div>
        )}
        {data.hasOwnProperty("hasTpWidget") && (
          <>
            <TpWidgetMicro
              className={`md:pt-2 ${
                data.hasOwnProperty("cta") ? "" : "md:ml-0"
              }`}
            />
          </>
        )}
      </article>{" "}
      <figure className="pos-rel lg:maxw-lg md:mt-5">
        <video
          autoPlay
          muted
          loop
          poster={data.video.preview}
          preload="none"
          playsInline
          className="w-100"
        >
          <source src={data.video.thumbnail} type="video/mp4" />
        </video>
        <ResponsiveImage
          src={data.image.src}
          alt={data.image.alt}
          dpi={data.image.prefixes.dpi}
          mobile={data.image.prefixes.mobile}
          className="md:w-100 fg-layer imgholder-tertiary"
        />
      </figure>
      <style jsx global>{`
        .hero--default .fg-layer {
          bottom: -20px;
        }
      `}</style>
      {data.hasOwnProperty("notes") && (
        <article className="notes lg:maxw-lg container md:m-0 md:pt-6">
          <span className="text-light-grayish-blue text-xs">*</span>
          <p className="lg:maxw-md md:text-smx text-light-grayish-blue text-xs">
            {data.notes}
          </p>
        </article>
      )}
      <style jsx global>{`
        .notes {
          display: inline-flex;
          margin-left: -5px;
          align-items: baseline;
        }
        @media (max-width: ${viewport.tablet.sm}) {
          .notes {
            margin-left: -7px !important;
          }
        }
      `}</style>
    </section>
  );
}
